export const iconFontAwesomeShoppingGem = (
	<i className="fa-solid fa-gem"></i>
);
